import React, { useState } from "react";
import i18next from "i18next";
import PropTypes from "prop-types";
import VeganToggle from "./VeganToggle";
import VeganOverlay from "./VeganOverlay";
// import VeganInlineNotification from "./VeganInlineNotification";
// import { VEGAN_TYPES } from "./VeganOptions";

// eslint-disable-next-line no-unused-vars
const VeganOptions = ({ veganType, veganAlternativeUrl, isBowl, isSalad }) => {
    const [loading, setLoading] = useState(false);
    // const [displayInlineNotification, setDisplayInlineNotification] = useState(
    //     veganType === VEGAN_TYPES.CLASSIC
    // );

    const getOverlayText = () => {
        return i18next.t(`productDetails.vegan.overlay.${veganType}`);
    };

    const toggleType = () => {
        setLoading(true);
        window.location.href = veganAlternativeUrl;
    };

    if (loading) {
        return <VeganOverlay text={getOverlayText()} />;
    }

    return (
        <>
            <div className="vegan-options">
                <p className="vegan-options_heading">
                    {i18next.t("productDetails.vegan.heading")}
                </p>
                <VeganToggle veganType={veganType} onToggle={toggleType} />
                {/* 
                TEMPORARY DISABLED
                
                {!!displayInlineNotification && (
                    <VeganInlineNotification
                        isBowl={isBowl}
                        isSalad={isSalad}
                        onClose={() => setDisplayInlineNotification(false)}
                    />
                )} */}
            </div>
        </>
    );
};

VeganOptions.propTypes = {
    veganType: PropTypes.string.isRequired,
    veganAlternativeUrl: PropTypes.string.isRequired,
    isBowl: PropTypes.bool,
    isSalad: PropTypes.bool,
};

export default VeganOptions;
